import React from 'react'
// import InfoIcon from '../../assets/icons/info-icon.svg'

import CheckBox from '../common/CheckBox'
// import SearchInput from '../common/SearchInput';
import AddressInput from '../common/AddressInput'
import Select from '../common/inputs/Select'
import { SelectionStore, ShoppersStore } from '../../store'
import { observer } from 'mobx-react-lite'
import { useText } from '../../texts'

const radiusVariants = ShoppersStore.filterOptions.radius

const ShopperFilterTab = observer(() => {
  const t = useText()
  const filter = SelectionStore.visitFilters
  const changeFilter = (key, value) =>
    SelectionStore.changeVisitsFilter(key, value)

  return (
    <div>
      <div className="filter-menu__title">{t('select-visits')}</div>
      <div className="range-label">{t('shopper-fact-address')}</div>
      <AddressInput
        id="address"
        placeholder={t('address')}
        value={filter.address}
        handle={(v) => changeFilter('address', v)}
      />

      <div className="filter-checkbox-row">
        <CheckBox
          value={filter.isLimit}
          handle={(v) => changeFilter('isLimit', v)}
          placeholder={t('visits-limit')}
        ></CheckBox>
      </div>
      <div className="filter-checkbox-row">
        <CheckBox
          value={filter.isRotation}
          handle={(v) => changeFilter('isRotation', v)}
          placeholder={t('with-rotation')}
        ></CheckBox>
      </div>
      <div className="filter-checkbox-row">
        <CheckBox
          value={filter.isStep}
          handle={(v) => changeFilter('isStep', v)}
          placeholder={t('with-step')}
        ></CheckBox>
      </div>

      <div className="range-label" style={{ marginTop: '3rem' }}>
        {t('search-radius')}
      </div>
      <Select
        placeholder={t('search-radius')}
        options={radiusVariants}
        getOptionLabel={(option) => t(option.label)}
        onChange={(v) => changeFilter('radius', v)}
        value={filter.radius?.label && t(filter.radius?.label)}
      ></Select>

      <div className="block-custom-scroll"></div>

      <div className="filter-list__bottom">
        <button
          className="btn btn-primary"
          onClick={() => SelectionStore.recommendVisits()}
        >
          {t('next')}
        </button>
      </div>
    </div>
  )
})
export default ShopperFilterTab
